import { useEffect, useState } from "react";
import * as configUtils from "util/config";

export const useComexAditionalDocs = () => {
    const [comexDocs, setComexDocs] = useState({});
    useEffect(() => {
        setComexDocs({
            codeImportDispatch: configUtils.get("comex.thuban.code.importDispatch", ""),
            codeComercialFact: configUtils.get("comex.thuban.code.invoice", ""),
            codeDeliveryDoc: configUtils.get("comex.thuban.code.deliveryDoc", ""),
            codeCertificate: configUtils.get("comex.thuban.code.certificate6401", ""),
            codeAccountingCertificate: configUtils.get("comex.thuban.code.accountingCertification", ""),
            codeDdjj: configUtils.get("comex.thuban.code.ddjj", ""),
            codeMiPyme: configUtils.get("comex.thuban.code.miPyme", ""),
            codeCTIT: configUtils.get("comex.thuban.code.CTIT", ""),
            codeSDEDI: configUtils.get("comex.thuban.code.SDEDI", ""),
            codeStatute: configUtils.get("comex.thuban.code.statute", ""),
            codeFile1: configUtils.get("comex.thuban.code.file1"),
            codeFile2: configUtils.get("comex.thuban.code.file2"),
            codeFile3: configUtils.get("comex.thuban.code.file3"),
            codeFile4: configUtils.get("comex.thuban.code.file4"),
            codeFile5: configUtils.get("comex.thuban.code.file5"),
            codeFile6: configUtils.get("comex.thuban.code.file6"),
            codeFile7: configUtils.get("comex.thuban.code.file7"),
            codeFile8: configUtils.get("comex.thuban.code.file8"),
            codeFile9: configUtils.get("comex.thuban.code.file9"),
            codeFile10: configUtils.get("comex.thuban.code.file10"),
        });
    }, []);

    return comexDocs;
};

export default useComexAditionalDocs;
